import useActiveIndustryData from "@/module/hook/useActiveIndustryData";

export default function Actions() {
  const { ActionBtn } = useActiveIndustryData();
  return <>{ActionBtn}</>;
}
